/**
 * Helper functions per gestione immagini
 */

/**
 * Costruisce URL completo per immagine
 * @param {string} imagePath - Path relativo immagine (es: /images/123.jpg)
 * @returns {string} URL completo
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';

  // In produzione usa path relativo, in dev usa localhost
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const baseUrl = apiUrl === '/api' ? '' : apiUrl;

  // Assicura che imagePath inizi con /
  const path = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;

  return `${baseUrl}${path}`;
};

/**
 * Componente Image con gestione URL automatica
 */
export const BackendImage = ({ imagePath, alt = '', className = '', ...props }) => {
  const imageUrl = getImageUrl(imagePath);

  return (
    <img
      src={imageUrl}
      alt={alt}
      className={className}
      onError={(e) => {
        // Fallback su immagine placeholder
        e.target.src = '/placeholder-plate.png';
      }}
      {...props}
    />
  );
};
